import script from "./TrainMotivates.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainMotivates.vue?vue&type=script&setup=true&lang=js"

import "./TrainMotivates.vue?vue&type=style&index=0&id=23ecf51e&lang=scss"

const __exports__ = script;

export default __exports__